function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 26.5,
  height: 46.5,
  rx: 4.25,
  fill: "#F0F4F8",
  stroke: "#6B7588",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  width: 12,
  height: 2.182,
  rx: 1,
  fill: "#6B7588"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.993 29.817h-.994L16.34 17h.994l-4.341 12.817zm-2.007-8.434l.016-1.16-4.986 3.104L6 24.487h.001L6 24.548l4.982 3.108.02-1.223-4.06-2.533 4.044-2.518zM22 23.333l-4.982-3.11-.02 1.223 4.06 2.534-4.044 2.518-.016 1.16 4.986-3.104.016-1.16h-.001v-.062z",
  fill: "#6B7588"
});

function SvgCodeTrigger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCodeTrigger;